import { FromSchema } from 'libs/entities/common/src/SchemaOperations';
import { z } from 'zod';

export const UploadInvoiceAttachmentSchema = z
    .object({
        fileName: z.string().min(1, 'File name is required'),
        url: z.string().url('Must be a valid URL').optional(),
        file: z.string().optional(), // Base64 encoded file string
    })
    .strict();

export class UploadInvoiceAttachmentDto extends FromSchema(UploadInvoiceAttachmentSchema) {
    fileName: string;
    url?: string;
    file?: string;
}
